import { render } from "./SpeakerInfoComponent.vue?vue&type=template&id=502b1a51"
import script from "./SpeakerInfoComponent.vue?vue&type=script&lang=js"
export * from "./SpeakerInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__